import { h, ComponentChildren } from 'preact'

interface ButtonGroupProps {
  direction?: 'horizontal' | 'vertical'
  children: ComponentChildren
}

export const ButtonGroup = ({ children, direction = 'horizontal' }: ButtonGroupProps) => (
  <div className={`m-button m-button--${direction}`}>
    {children}
  </div>
)
